import { useMutation, MutationHookOptions } from '@companyon/graphql';
import { REGISTER_DEVICE_MUTATION } from '../../schema/mutations/registerDevice';

export function useRegisterDeviceMutation(options?: MutationHookOptions) {
  return useMutation(REGISTER_DEVICE_MUTATION, options);
}
